export default {
  Deliberacoes: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "deliberacao"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Deliberacoes.js
// module id = 0Eix
// module chunks = 13